import React, {Component} from 'react'
import WorkersPage from "./WorkersPage"
import {_getListWorker} from "../../../../../services/apis/WorkerServices"

class WorkersPageContainer extends Component {
    state = {
        docs: [],
        total: 0,
        pagination: {
            page: 1,
            limit: 1000,
            maxPage: 1,
        },
        error: '',
        isModalOpen: false,
        modalData: {
            id: '',
            username: '',
            password: '',
            proxy: '',
            note: '',
            secretCode: ''
        }
    }

    _refresh = null

    componentDidMount() {
        this._fetchWorkerInfo()
        this._refresh = setInterval(() => {
            this._fetchWorkerInfo()
        }, 5000)
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._refresh)
    }

    _removeWorkerFormState = (id) => {
        this.setState(({docs}) => ({
                docs: docs.filter(worker => worker._id !== id)
            })
        )
    }

    _fetchWorkerInfo = () => {
        const {page, limit} = this.state.pagination
        _getListWorker(page, limit)
            .then(result => {
                if (result.success) {
                    this.setState(prevState => ({
                        total: result.data.total,
                        docs: result.data.docs,
                        pagination: {
                            ...prevState.pagination,
                            maxPage: result.data.pages,
                        }
                    }))
                } else {
                    this.setState({
                        error: result.message,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    _handleChangePage = (page) => {
        const {limit} = this.state.pagination
        this.setState(prevState => ({
                pagination: {
                    ...prevState.pagination,
                    page,
                }
            })
        )
        _getListWorker(page, limit)
            .then(result => {
                if (result.success) {
                    this.setState(prevState => ({
                        total: result.data.total,
                        docs: result.data.docs,
                        pagination: {
                            ...prevState.pagination,
                            maxPage: result.data.pages,
                        }
                    }))
                } else {
                    this.setState({
                        error: result.message,
                    })
                }
            })
    }

    _toggleModal = () => {
        this.setState(({isModalOpen}) => ({
            isModalOpen: !isModalOpen
        }))
    }

    _closeModal = () => {
        this.setState({
            isModalOpen: false,
        })
    }

    _changeModalData = (modalData) => {
        this.setState({
            modalData,
        })
    }
    _handleUpdateListWorker = ({id, username, password, proxy, secretCode}) => {
        this.setState(({docs}) => ({
            docs: docs.map(worker => {
                if (worker._id !== id) {
                    return worker
                }
                return {
                    ...worker,
                    username,
                    password,
                    proxy,
                    secretCode
                }
            })
        }))
    }

    render() {
        const {isModalOpen, modalData} = this.state
        return (
            <WorkersPage {...this.state} onChangePage={this._handleChangePage}
                         onRefreshPage={this._fetchWorkerInfo}
                         removeWorkerFormState={this._removeWorkerFormState}
                         onToggleModal={this._toggleModal}
                         onCloseModal={this._closeModal}
                         onChangeModalData={this._changeModalData}
                         isModalOpen={isModalOpen}
                         modalData={modalData}
                         onUpdateListWorker={this._handleUpdateListWorker}/>
        )
    }
}

export default WorkersPageContainer



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/WorkersPageContainer.js